import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import SortBy from "../components/SortBy";
import DownloadBtn from "../components/DownloadBtn";
// import StudentInProgressTable from '../components/StudentInProgressTable';
import { useDispatch, useSelector } from "react-redux";
import StudentPendingTable from "../components/StudentPendingTable";
import {
  fetchStudentApplicationApproval,
  setUpdateStudentsPageSize,
  setUpdateStudentsPagination,
  setUpdateStudentsStatus,
} from "../redux/slices/studentApplicationApprovalSlice";
import StudentApprovedTable from "../components/StudentApprovedTable";
import StudentDeclinedTable from "../components/StudentDeclinedTable";

const Student = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  const StudentApplication = useSelector(
    (state) => state?.studentApplicationApproval
  );

  const getAllStudentApplication = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchStudentApplicationApproval());
      if (response?.payload?.name === "AxiosError") {
        setLoading(false);
        setError(
          response?.payload?.response?.data?.errors?.map((errors) => errors) ||
            response?.payload?.response?.data?.error?.description ||
            "Failed to get student Applications"
        );
      }
      setLoading(false);
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get student Applications, please check your network"
      );
    }
  }, [dispatch]);

  useEffect(() => {
    getAllStudentApplication();
  }, [getAllStudentApplication, StudentApplication?.studentsParams]);

  const handleStatusChange = (status) => {
    dispatch(setUpdateStudentsStatus(status));
    // getAllStudentApplication();
  };

  const handlePagination = (page) => {
    dispatch(setUpdateStudentsPagination(page));
  };

  const handlePageSize = (size) => {
    dispatch(setUpdateStudentsPageSize(size));
  };

  const StudentAppData = {
    handlePagination,
    handlePageSize,
    itemsPerPage: StudentApplication?.students?.currentPageRecord,
    totalRecord: StudentApplication?.students?.totalRecord,
    pageNumber: StudentApplication?.studentsParams?.page,
    nextPage: StudentApplication?.students?.nextPage,
    previousPage: StudentApplication?.students?.previousPage,
    pageSize: StudentApplication?.studentsParams?.pageSize,
  };

  return (
    <Box pt={2} pb={5} minH={"100vh"} px={3}>
      <Flex
        bg={"#FFFFFF"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={"20px"}
        py={2}
        px={3}
        mb={5}
      >
        <Text fontSize={"18px"} fontWeight={"700"} color={"#23A455CC"}>
          Student Application
        </Text>
        <Flex
          flexDirection={["column", "column", "row"]}
          alignItems={"center"}
          gap={[3, null, null]}
        >
          <SortBy />
          <DownloadBtn />
        </Flex>
      </Flex>
      <Tabs variant="unstyled">
        <TabList
          gap={"20px"}
          flexDirection={["column", "row", "row"]}
          pb={4}
          justifyContent={["center", "flex-start", "flex-start"]}
          alignItems={"center"}
        >
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Pending")}
          >
            Pending
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Approved")}
          >
            Approved
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Declined")}
          >
            Declined
          </Tab>
          {/* <Tab _selected={{ color: '#FFFFFF', bg: '#D11A2A' }}
         bg={'#E9E9E9'} w={['100%', '18%', '18%', '18%']}  borderRadius={'4px'} lineHeight={'-0.25px'} color={'#54595F'}
        >In-progress</Tab> */}
        </TabList>

        <TabPanels bg={"#FFFFFF"}>
          <TabPanel>
            <StudentPendingTable
              StudentApplication={StudentApplication?.students}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...StudentAppData}
            />
          </TabPanel>
          <TabPanel>
            <StudentApprovedTable
              StudentApplication={StudentApplication?.students}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...StudentAppData}
            />
          </TabPanel>
          <TabPanel>
            <StudentDeclinedTable
              StudentApplication={StudentApplication?.students}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...StudentAppData}
            />
          </TabPanel>
          {/* <TabPanel>
          <StudenInProgressTable />
        </TabPanel> */}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Student;
